import api from './api';

export const dashboardService = {
  async getMyDashboard(params = {}) {
    const response = await api.get('/dashboards/me', { params });
    return response.data;
  },

  async getTeamDashboard(params = {}) {
    const response = await api.get('/dashboards/team', { params });
    return response.data;
  }
};
